(function () {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.nbs-carousel').forEach(carousel => {
      const items = Array.from(carousel.children);
      const totalItems = items.length;

      let windowWidth = window.innerWidth;
      let activeIndex = Array.from(items).findIndex(item => item.classList.contains('current'));
      let slide = activeIndex >= 0 ? activeIndex : 0;

      const activateItem = (index) => {
        const dots = Array.from(carousel.querySelectorAll('.nbs-carousel__dots div'));

        items.forEach(item => item.classList.remove('current'));
        items[index].classList.add('current');

        dots.forEach(dot => dot.classList.remove('current'));
        dots[index].classList.add('current');
      };

      const gotoNext = () => {
        let next = slide + 1;
        slide = next >= totalItems ? 0 : next;
        activateItem(slide);
      };

      const gotoPrev = () => {
        let prev = slide - 1;
        slide = prev < 0 ? totalItems - 1 : prev;
        activateItem(slide);
      }

      const addArrows = () => {
        const arrowLeft = document.createElement('button');
        const arrowLeftText = document.createElement('span');

        arrowLeft.classList.add('nbs-carousel__arrow', 'nbs-carousel__arrow--left');
        arrowLeftText.classList.add('sr-only');
        arrowLeftText.textContent = 'Tidligere';
        arrowLeft.appendChild(arrowLeftText);
        arrowLeft.addEventListener('click', gotoPrev);

        const arrowRight = document.createElement('button');
        const arrowRightText = document.createElement('span');

        arrowRight.classList.add('nbs-carousel__arrow', 'nbs-carousel__arrow--right');
        arrowRightText.classList.add('sr-only');
        arrowRightText.textContent = 'Neste';
        arrowRight.appendChild(arrowRightText);
        arrowRight.addEventListener('click', gotoNext);

        carousel.appendChild(arrowLeft);
        carousel.appendChild(arrowRight);
      };
      addArrows();

      const addDots = (totalItems) => {
        const dots = document.createElement('div');

        dots.classList.add('nbs-carousel__dots');

        for (let i = 0; i < totalItems; i++) {
          const dot = document.createElement('div');

          dot.addEventListener('click', () => activateItem(i));
          dots.appendChild(dot);
        }

        carousel.appendChild(dots);
      }
      addDots(totalItems);

      // Intersection observer to detect when an item is in view.
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            const index = Array.from(items).findIndex(item => item === entry.target);
            activateItem(index);
          }
        });
      }, {
        threshold: 0.5
      });

      window.addEventListener('resize', () => {
        windowWidth = window.innerWidth;

        if (windowWidth < 768) {
          items.forEach(item => observer.observe(item));

        } else {
          items.forEach(item => observer.unobserve(item));
        }
      });

      if (windowWidth < 768) items.forEach(item => observer.observe(item));

      activateItem(slide);
      if (!carousel.classList.contains('ready')) carousel.classList.add('ready');
    });
  });
})();